// extracted by mini-css-extract-plugin
export default {"content":"LinkCopy_content__J+5fM"};